{
  "INTEGRATION_APPS": {
    "FETCHING": "Fetching Integrations",
    "NO_HOOK_CONFIGURED": "There are no {integrationId} integrations configured in this account.",
    "HEADER": "Applications",
    "COUNT": "{n} integration | {n} integrations",
    "SEARCH_PLACEHOLDER": "Search...",
    "NO_RESULTS": "No results found matching your search",
    "STATUS": {
      "ENABLED": "Käytössä",
      "DISABLED": "Pois käytöstä"
    },
    "CONFIGURE": "Määrittele",
    "ADD_BUTTON": "Add a new hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Confirm deletion",
        "ACCOUNT": "Disconnect"
      },
      "MESSAGE": {
        "INBOX": "Oletko varma että haluat poistaa?",
        "ACCOUNT": "Are you sure to disconnect?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Kyllä, poista",
        "ACCOUNT": "Yes, Disconnect"
      },
      "CANCEL_BUTTON_TEXT": "Peruuta",
      "API": {
        "SUCCESS_MESSAGE": "Hook deleted successfully",
        "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
      }
    },
    "LIST": {
      "FETCHING": "Fetching integration hooks",
      "INBOX": "Inbox",
      "ACTIONS": "Toiminnot",
      "DELETE": {
        "BUTTON_TEXT": "Poista"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Select Inbox",
          "PLACEHOLDER": "Select Inbox"
        },
        "SUBMIT": "Luo",
        "VALIDATING_OPENAI": "Validating with OpenAI...",
        "CANCEL": "Peruuta"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integration hook added successfully",
        "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Yhdistä"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Disconnect"
    },
    "SIDEBAR_DESCRIPTION": {
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details"
    }
  }
}
